import React from 'react'

import PageLink from '@/link.js'
import Image from '@/image.js'

const CtaModule = ({ content }) => {
  const handleCTA = (ctaLink) => {
    switch (ctaLink) {
      case 'membersPage':
        return '/membership'
      case 'aboutPage':
        return '/about'
      default:
        return '/'
    }
  }
  return (
    <div className='x container--xl ma p1 ac pmy'>
      <h2 className='light h2'>{content.title}</h2>
      <div className='f jcb ai fw cta__wrapper'>
        {content.nestedCTAs.map(cta => (
          <div className='x shadow__box bcw mb15' key={cta._key}>
            <div className='rel bcw'>
              <Image timeOut={400} imageId={cta.imageId} className='x' />
              <div className='pt1 pb05 px15 cta__text ac'>
                <h3 className='mb0 mt05 pb0'>{cta.title}</h3>
                <p className='cta__desc'>{cta.description}</p>
                <div className='mb1 pt05 block'>
                  <PageLink to={handleCTA(cta.ctaLink._ref)} className='button mb1 inline-block button__peach button__outline'>
                    <span>{cta.ctaCopy}</span>
                  </PageLink>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
        }

export default CtaModule